import {v3} from "@alchemiesolns/maths";

export const getLargestAngle = (bonds: number[][]) => {
    if(bonds.length <= 1) {
        const angle = 2*Math.PI
        let vect = [1,0]

        if(bonds.length === 1) {
            vect = bonds[0];
        }
        return {largestAngle: angle, startVect: vect};
    }

    // Find the closest vector to each vector going clockwise.
    const closestAngles: number[] = [];
    const closestVects = [];

    bonds.forEach((b) => {
        let smallestAngle = Infinity;
        let smallestVect = -1;
        const a1 = Math.atan2(b[1], b[0]);
        bonds.forEach((b2,i) => {
            const a2 = Math.atan2(b2[1], b2[0]);
            let angle = a2 - a1;
            if(angle < 0) {
                angle = Math.PI*2.0 - a1 + a2;
            }

            if( angle < smallestAngle && angle > 0) {
                smallestAngle = angle;
                smallestVect = i;
            }
        })
        closestAngles.push(smallestAngle);
        closestVects.push(smallestVect);
    })

    // Out of the closest angles, find the angle that is the greatest (most space between angle to place the lp)
    let largestAngle = 0;
    let startVect = bonds[0];

    closestAngles.forEach((a, i) => {
        if(a > largestAngle &&  a < Infinity) {
            largestAngle = a;
            startVect = bonds[i];
        }
    })
    return {largestAngle: Math.abs(largestAngle), startVect};
}

export const calcVect = (startVect: number[], angle: number) => {
    const x2 = Math.cos(angle)*startVect[0] - Math.sin(angle)*startVect[1];
    const y2 = Math.sin(angle)*startVect[0] + Math.cos(angle)*startVect[1];

    return v3.normalize([x2,y2,0]);
}